import React, { useState } from 'react';
import { ReactComponent as CopyIcon } from '../../assets/svg/copyIcon.svg';
import css from './CopyToClipBoard.module.css';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
function CopyToClipBoard({ copiedText }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    setCopied(true);

    navigator.clipboard.writeText(copiedText);
    setTimeout(() => {
      setCopied(false);
    }, 1300);
  };
  return (
    <div className={css.copyContainer}>
      <div
        className={classNames(css.copiedText, {
          [css.copiedTextShow]: copied,
        })}
      >
        <FormattedMessage id="CopyToClipBoard.Copied" />
      </div>

      <div className={css.CopyIcon} onClick={handleCopy}>
        <CopyIcon />
      </div>
    </div>
  );
}

export default CopyToClipBoard;
